import { makeStyles } from '@mui/styles';

import { BackgroundColors, Colors, Fonts } from 'styleguide-v2';

export const useCommonStyles = makeStyles({
  cardContainer: {
    '&& h4': {
      alignSelf: 'flex-start',
      textTransform: 'uppercase',
      fontSize: `calc(${Fonts.fontSize} * .625)`,
      fontFamily: Fonts.fontWorkSans,
      lineHeight: '12px',
      margin: '0.25rem 0 0',
    },
    '&& h4 + :not(h4)': {
      fontSize: `calc(${Fonts.fontSize} * .875)`,
      margin: '0',
    },
    '&& p + p': {
      alignSelf: 'flex-start',
      lineHeight: '12px',
      margin: '0.25rem 0 0',
    },
    '&& p': {
      marginBottom: '0.25rem',
    },
    '&& > .grid-wrapper > .grid-wrapper': {
      gridTemplateRows: 'max-content',
    },
    '&& > .grid-wrapper > .grid-wrapper:not(:last-child)': {
      borderRight: '2px solid #f4f7f6',
      paddingRight: '7px',
    },
  },
  column: {
    height: 'fit-content',
    gap: '0 20px',
    paddingLeft: '5px',

    '&:not(:last-child)': {
      borderRight: `2px solid ${BackgroundColors.gray}`,
      paddingRight: '15px',
    },
  },
  firstIcon: {
    '&&': {
      marginTop: '2.5rem',
    },
  },
  icon: {
    '&&': {
      marginTop: '.25rem',
    },
  },
  itemMarginBottom: {
    marginBottom: '25px',
  },
  itemLabel: {
    '&&': {
      alignSelf: 'flex-start',
      textTransform: 'uppercase',
      fontSize: `calc(${Fonts.fontSize} * .625)`,
      fontFamily: Fonts.fontWorkSans,
      marginTop: '0',
    },
  },
  itemValue: {
    '&&': {
      alignSelf: 'flex-start',
      fontSize: `calc(${Fonts.fontSize} * .875)`,
    },
  },

  addIcon: {
    marginTop: '-0.25rem',
  },
  addLink: {
    color: Colors.textGreen,
    fontSize: '0.875em',
    marginLeft: '0.5rem',
    textDecoration: 'underline',

    '&:hover': {
      color: Colors.iconGreen,
    },
  },
});
